import { modalAnatomy as parts } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';
import { type StyleFunctionProps } from '@chakra-ui/theme-tools';
import { Colors, TextStyles, Shadows, Space, Radii, FontWeights } from '../../types';
const { defineMultiStyleConfig, definePartsStyle } = createMultiStyleConfigHelpers(parts.keys);

const baseStyle = definePartsStyle((props: StyleFunctionProps) => {
  return {
    header: {
      textStyle: TextStyles.H2,
      fontWeight: FontWeights.BOLD,
      color: Colors.TEXT_EMPHASIS,
      px: { base: Space.MD, sm: Space.LG },
      pt: Space.MD,
      pb: Space.SM,
      margin: 0,
    },
    closeButton: {
      position: 'absolute',
      top: Space.SM,
      right: Space.SM,
    },
    body: {
      color: Colors.TEXT_MUTED,
      boxShadow: props.scrollBehavior === 'inside' ? Shadows.INNER : undefined,
      borderWidth: props.scrollBehavior === 'inside' ? '1px 0' : undefined,
      textStyle: TextStyles.P2,
      px: { base: Space.MD, sm: Space.LG },
      py: Space.SM,
      gap: Space.XS,
    },
    dialog: {
      bg: Colors.SURFACE_ELEVATED,
      boxShadow: Shadows.XL,
      borderRadius: Radii['2XL'],
      outline: '1px solid',
      outlineColor: Colors.BORDER_ELEVATED,
    },
    footer: {
      paddingStart: { sm: Space.LG },
      gap: Space.SM,
      px: Space.MD,
      pt: Space.SM,
      pb: Space.MD,
    },
    overlay: {
      bg: Colors['BLACKALPHA.300'],
      _dark: { bg: Colors['BLACKALPHA.600'] },
    },
  };
});

export const Modal = defineMultiStyleConfig({ baseStyle });
